import { useState, useEffect, useRef, useMemo } from 'react';
import { LuArrowUpDown } from 'react-icons/lu';
import { ml } from 'src/_shared/services/utils.js';
import { accentRgba } from './utils.js';

function SortDropdown({
	sortBy,
	onSortChange,
	currentUser,
	allMultiLingualData,
	accentColor,
}) {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);

	const options = useMemo(() => [
		{
			value: 'newest',
			label: ml('Newest first', currentUser, allMultiLingualData),
		},
		{
			value: 'oldest',
			label: ml('Oldest first', currentUser, allMultiLingualData),
		},
		{ value: 'title', label: ml('A to Z', currentUser, allMultiLingualData) },
	], [currentUser, allMultiLingualData]);

	const currentLabel = options.find((o) => o.value === sortBy)?.label || '';

	useEffect(() => {
		const handleClickOutside = (e) => {
			if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	return (
		<div ref={dropdownRef} style={{ position: 'relative' }}>
			<button
				type="button"
				onClick={() => setIsOpen(!isOpen)}
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 8,
					paddingLeft: 12,
					paddingRight: 14,
					paddingTop: 10,
					paddingBottom: 10,
					background: '#fff',
					border: '1px solid #e2e8f0',
					borderRadius: 12,
					color: '#475569',
					fontSize: 14,
					fontWeight: 500,
					cursor: 'pointer',
					transition: 'all 0.2s',
					whiteSpace: 'nowrap',
				}}
			>
				<LuArrowUpDown size={14} color="#94a3b8" />
				{currentLabel}
			</button>

			{isOpen && (
				<div
					style={{
						position: 'absolute',
						top: 'calc(100% + 6px)',
						right: 0,
						background: '#fff',
						border: '1px solid #e2e8f0',
						borderRadius: 12,
						boxShadow:
							'0 10px 25px -5px rgba(0,0,0,0.1), 0 4px 10px -5px rgba(0,0,0,0.04)',
						zIndex: 1000,
						overflow: 'hidden',
						minWidth: 160,
					}}
				>
					{options.map((option) => (
						<button
							key={option.value}
							type="button"
							onClick={() => {
								onSortChange(option.value);
								setIsOpen(false);
							}}
							style={{
								display: 'flex',
								alignItems: 'center',
								width: '100%',
								padding: '7px 14px',
								background:
									sortBy === option.value
										? accentRgba(accentColor, 0.08)
										: '#fff',
								color: sortBy === option.value ? accentColor : '#475569',
								fontWeight: sortBy === option.value ? 600 : 400,
								fontSize: 13,
								border: 'none',
								cursor: 'pointer',
								transition: 'all 0.15s',
								textAlign: 'left',
							}}
							onMouseOver={(e) => {
								if (sortBy !== option.value) {
									e.currentTarget.style.background = '#f8fafc';
								}
							}}
							onMouseOut={(e) => {
								e.currentTarget.style.background =
									sortBy === option.value
										? accentRgba(accentColor, 0.08)
										: '#fff';
							}}
						>
							{option.label}
						</button>
					))}
				</div>
			)}
		</div>
	);
}

export default SortDropdown;
